import { createContext, useContext, useState } from "react";

const ResultContext = createContext();

export function ResultProvider({ children }) {
  const [data, setData] = useState({});

  return (
    <ResultContext.Provider value={{ data, setData }}>
      {children}
    </ResultContext.Provider>
  );
}

export const useResult = () => useContext(ResultContext);
